import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }

import ActionMenuAlt from "@/components/common/ActionMenuAlt.vue";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { DotsHorizontalIcon, EyeIcon } from "@heroicons/vue/solid";
import {
  TransferAuthorityStatuses,
  TransferAuthorityUserTypes,
} from "@/store/modules/transferAuthority/state";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
  status: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
},
  emits: ["close", "deny", "confirm", "reason"],
  setup(__props, { emit }) {

const props = __props

const store = useStore();



const isShow = ref(false);

const dropDownActions = computed(() => {
  const actions = [
    {
      text: t("common.details"),
      icon: EyeIcon,
      iconColor: "text-slate-500",
      action: () => {
        emit("reason");
      },
    },
  ];

  if (
    props.type === TransferAuthorityUserTypes.IOUSER &&
    props.status === TransferAuthorityStatuses.WAIT_CONFIRM
  ) {
    actions.push({
      text: "Подтвердить",
      action: () => {
        emit("confirm");
      },
    });
  }

  if (
    props.type === TransferAuthorityUserTypes.USER &&
    (props.status === TransferAuthorityStatuses.ACTIVE ||
      props.status === TransferAuthorityStatuses.WAIT_CONFIRM)
  ) {
    actions.push({
      text: "Закрыть",
      action: () => {
        emit("close");
      },
    });
  }

  if (
    props.type === TransferAuthorityUserTypes.IOUSER &&
    (props.status === TransferAuthorityStatuses.WAIT_CONFIRM ||
      props.status === TransferAuthorityStatuses.ACTIVE)
  ) {
    actions.push({
      text: "Отказать",
      action: () => {
        emit("deny");
      },
    });
  }

  return actions;
});

const indexOpen = ref<number | null>(null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DotsHorizontalIcon), {
      class: "w-6 h-6 text-gray-600 cursor-pointer",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isShow.value = true), ["prevent"]))
    }),
    _createVNode(ActionMenuAlt, {
      class: "top-0 right-0",
      actions: _unref(dropDownActions),
      "is-open": isShow.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (isShow.value = false))
    }, null, 8, ["actions", "is-open"])
  ]))
}
}

})